import {
  Box,
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  MenuItem,
  Select,
  FormControl,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import {
  Search,
  Close,
  Edit,
  GetApp,
  Print,
  Visibility,
    Lock,
    LockOpenTwoTone,
  KeyboardArrowRight,
  KeyboardArrowDown,
  History,
  Email,
} from "@material-ui/icons";
import React, { useContext, useEffect, useState, useCallback } from "react";
import { debounce } from 'lodash';
import ModalSearchInstitutions, {
  CbInstituteProps,
} from "../../../components/ModalSearchInstitutions";
import { blockReport, unblockReport, getReportPDFBase64, getReports, getZipByLote, generatePdf, getPdfStatus, downloadPdfZip } from "../service";

import DataGrid from "../../../components/DataGrid";
import useStyles from "../style";
import history from "../../../routes/history";
import { useFormik } from "formik";
import { format } from "date-fns";
import DialogHistoryReport from "./DialogHistoryReport";
import DialogSendMailReport from "./DialogSendMailReport";
import ShowHasPermission from "../../../utils/showHasPermission";
import ModalConfirmation from "../../../components/ModalConfirmation";
import { Context } from "../../../providers/AuthProvider/contexts/AuthContext";
import { useMediaQuery } from "react-responsive";
import StatusCustomRenderTypes from "../../../components/StatusCustomRenderTypes";
import openPdfBlob from "../../../utils/openPdfBlob";
import Snackbar from "../../../components/Snackbar";
import CircularProgress from "@material-ui/core/CircularProgress";

const ReportsPjIJC = () => {
  const classes = useStyles();

  const initialState: CbInstituteProps[] = [];

  const [data, setData] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [selectedInstitutes, setSelectedInstitutes] =
    useState<CbInstituteProps[]>(initialState);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [expand, setExpand] = useState<string | false>("filter");
    const [openHistory, setOpenHistory] = useState(false);
    const [idReportHistory, setIdReportHistory] = useState("");
    const [idSolicitacaoLis, setIdSolicitacaoLis] = useState("");
  const [openSendEmail, setOpenSendEmail] = useState(false);
  const [idSendEmail, setIdSendEmail] = useState("");
  const [labelPrescription, setLabelPrescription] = useState("Prescrição");
  const [reportIdItemChanged, setReportIdItemChanged] =
    useState<boolean>(false);
  const [reportId, setReportId] = useState<string>("");
  const [searching, setSearching] = useState<boolean>(false);
  const { user } = useContext(Context);
    const isTablet = useMediaQuery({ minWidth: 600, maxWidth: 1100 });
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 599px)' });
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [resetInstitutesSelection, setResetInstitutesSelection] = useState(false)
    const [loading, setLoading] = useState(false);

  const reports = (page: number) => {
      const filters = formik.values;

      getReports(filters, page, 10).then((response) => {
      setData(response.reportPageResponse.content);
      setTotalPages(response.reportPageResponse.totalPages);
    });
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleChangeInstituteIcon = (event: any) => {
    event.stopPropagation();
    setSelectedInstitutes(initialState);
    formik.setFieldValue("InstituteIds", []);
        setResetInstitutesSelection(true);
  };

  const handleSearchInstitute = async (callback: CbInstituteProps[]) => {
    const ids = callback.map(institute => institute.tasyCode);
    formik.setFieldValue("InstituteIds", ids);
    setSelectedInstitutes(callback);
    setResetInstitutesSelection(false);
  };


    const columns = [
        {
            name: "prescription",
            label: labelPrescription,
            width: "15%",
             minWidth: "123px",
            sortable: true,
            customRender: (index: any) => {
                if (data != null && data[index] != null && data[index].prescription) {
                    const version = labelPrescription === "Prescrição / Versão" ? " / " + data[index].versionNumber : "";
                    return data[index].prescription + version;
                }

                return "";
            }
        },
        {
            name: "batch",
            label: "Lote",
            width: "5%",
            minWidth: "105px",
            sortable: true,

        },
        {
            name: "dnv",
            label: "DNV",
            width: "5%",
             minWidth: "123px",
        },
        
        {
            name: "namePatient",
            label: "Nome Criança",
            sortable: true,
            width: "10%",
            minWidth: "200px",
        },
        {
            name: "bornDate",
            label: isTablet || isTabletOrMobile ? "Nascimento" : "Data de Nascimento",
            width: "15%",
            minWidth: "175px",
            customRender: (index: any) => {
                if (data != null && data[index] != null && data[index].bornDate) {
                    const date = data[index].bornDate;
                    const [datePart, timePartRaw] = date.split(' - ');
                    const [day, month, year] = datePart.split('/');
                    const timePart = timePartRaw && timePartRaw.trim() !== "" ? timePartRaw : "00:00:00";
                    const formattedDate = `${year}-${month}-${day}T${timePart}`;

                    return date ? format(new Date(formattedDate), "dd/MM/yyyy - HH:mm") : "";
                }

                return "";
            }
        },
        {
            name: "collectionDate",
            label: isTablet || isTabletOrMobile ? "Coleta" : "Data da Coleta",
            width: "10%",
            minWidth: "140px",
        },
        {
            name: "signDate",
            label: isTablet || isTabletOrMobile ? "Assinatura" : "Data da Assinatura",
            width: "10%",
            minWidth: "140px",
        },
        {
            name: "motherName",
            label: "Filiação",
            width: "10%",
            minWidth: "244px",
        },
        {
            name: "status",
            label: "",
            width: "10%",
            minWidth: "187px",
            customRender: (index: any) => (
                <StatusCustomRenderTypes data={data[index]} />
            ),
        },
        {
            name: "",
            label: "",
            width: "20%",
            minWidth: "181px",
            customRender: (index: any) => {
                return (
                    <>
                        <div
                            className="actions"
                            style={
                                isTablet
                                    ? { flexDirection: "column" }
                                    : { flexDirection: "row" }
                            }
                        >
                            <span className="option">
                                <Visibility
                                    titleAccess="Visualizar"
                                    onClick={() => showPdfNewTab(data[index].reportId, 1)}
                                    style={{ pointerEvents: data[index] != null && data[index].status === 'Bloqueado' && user?.typeUser != 0 ? 'none' : 'auto', color: data[index] != null && data[index].status === 'Bloqueado' && user?.typeUser != 0 ? 'grey' : 'inherit' }}
                                />
                            </span>

                            <span className="option">
                                <GetApp
                                    titleAccess="Download"
                                    onClick={() => {
                                        if (data[index] != null && (data[index].status !== 'Bloqueado' || user?.typeUser == 0)) {
                                            downloadPdf(data[index], 2);
                                        }
                                    }}
                                    style={{ pointerEvents: data[index] != null && (data[index].status === 'Bloqueado' && user?.typeUser != 0) ? 'none' : 'auto', color: data[index] != null && (data[index].status === 'Bloqueado' && user?.typeUser != 0) ? 'grey' : 'inherit' }}
                                />
                            </span>

                            <span className="option">
                                <Print
                                    titleAccess="Imprimir"
                                    onClick={() => {
                                        if (data[index] != null && data[index].status !== 'Bloqueado') {
                                            printPDFInApp(data[index].reportId, 3);
                                        }
                                    }}
                                    style={{ pointerEvents: data[index] != null && data[index].status === 'Bloqueado' ? 'none' : 'auto', color: data[index] != null && data[index].status === 'Bloqueado' ? 'grey' : 'inherit' }}
                                />
                            </span>

                            {ShowHasPermission("Laudo_EnvioEmail") && (
                                <span className="option">
                                    <Email
                                        titleAccess="Enviar laudo por email"
                                        onClick={() => {
                                            if (data[index] != null && data[index].status !== 'Bloqueado') {
                                                openDialogSendEmail(data[index].reportId);
                                            }
                                        }}
                                        style={{ pointerEvents: data[index] != null && data[index] != null && data[index].status === 'Bloqueado' ? 'none' : 'auto', color: data[index] != null && data[index].status === 'Bloqueado' ? 'grey' : 'inherit' }}
                                    />
                                </span>
                            )}

                            {ShowHasPermission("Laudo_Bloqueio") && data[index] != null && data[index].status !== 'Bloqueado' && (
                                <span className="option">
                                    <Lock
                                        titleAccess="Bloquear"
                                        onClick={() => handleOpenModalConfirmation(data[index])}
                                    />
                                </span>
                            )}

                            {ShowHasPermission("Laudo_Desbloqueio") && data[index] != null && data[index].status === 'Bloqueado' && (
                                <span className="option">
                                    <LockOpenTwoTone
                                        titleAccess="Desbloquear"
                                        onClick={() => handleOpenModalConfirmationUnblock(data[index])}
                                    />
                                </span>
                            )}

                            {ShowHasPermission("Laudo_SolicitacaoAlteraçãoDados") && (
                                <span className="option">
                                    <Edit
                                        titleAccess="Editar"
                                        onClick={() => {
                                            if (data[index] != null && data[index].status !== 'Bloqueado') {
                                                history.push(`/laudo/alterar-dados/${data[index].reportId}`);
                                            }
                                        }}
                                        style={{ pointerEvents: data[index] != null && data[index].status === 'Bloqueado' ? 'none' : 'auto', color: data[index] != null && data[index].status === 'Bloqueado' ? 'grey' : 'inherit' }}
                                    />
                                </span>
                            )}

                            {ShowHasPermission("Laudo_Historico") && (
                                <span className="option">
                                    <History
                                        titleAccess="Histórico"
                                        onClick={() => openDialogHistory(data[index].prescription, data[index].solicitacaoLis)}
                                    />
                                </span>
                            )}
                        </div>
                    </>
                );
            },
        },
    ];

    const [idReportBlock, setIdReportBlock] = useState(0);
    const [idReportUnblock, setIdReportUnblock] = useState(0);
  const [confirmationModal, setConfirmationModal] = useState({
    open: false,
    message: <></>,
  });
    const [confirmationModalUnblock, setConfirmationModalUnblock] = useState({
        open: false,
        message: <></>,
    });

  const handleBlockReport = () => {
    blockReport(idReportBlock).then(() => reports(page));
    };
    const handleUnblockReport = () => {
        unblockReport(idReportUnblock).then(() => reports(page));
    };

  const handleOpenModalConfirmation = (row: any) => {
    setIdReportBlock(row.reportId);
    const namePatient = row.namePatient;
    const message = (
      <>
        Deseja realmente bloquear o laudo de: <b>{namePatient}?</b>
      </>
    );

    setConfirmationModal({
      open: true,
      message: message,
    });
    };

    const handleOpenModalConfirmationUnblock = (row: any) => {
        setIdReportUnblock(row.reportId);
        const namePatient = row.namePatient;
        const message = (
            <>
                Deseja realmente desbloquear o laudo de: <b>{namePatient}?</b>
            </>
        );

        setConfirmationModalUnblock({
            open: true,
            message: message,
        });
    };

  const handleCloseModalConfirmation = () => {
    setConfirmationModal({
      open: false,
      message: confirmationModal.message,
    });
    };

    const handleCloseModalConfirmationUnblock = () => {
        setConfirmationModalUnblock({
            open: false,
            message: confirmationModalUnblock.message,
        });
    };

  const showPdfNewTab = (reportId: string, visualizationType: number) => {
    setReportIdItemChanged(true);
    setReportId(reportId);
      setSearching(false);

    getReportPDFBase64(reportId, visualizationType).then((pdfBase64) => {
      const contentType = "application/pdf";
      const blob = b64toBlob(pdfBase64, contentType);
      const blobUrl = openPdfBlob(blob);

      window.open(blobUrl, "_blank");
    });
  };

  const downloadPdf = (report: any, visualizationType: number) => {
    setReportIdItemChanged(true);
    setReportId(report.reportId);
    setSearching(false);

      getReportPDFBase64(report.reportId, visualizationType).then((pdfBase64) => {
      const contentType = "application/pdf";
      const blob = b64toBlob(pdfBase64, contentType);
      const blobUrl = openPdfBlob(blob);

      var objDownload = document.createElement("a");
      objDownload.download = `Laudo - ${report.namePatient} - ${report.collectionDate}`;
      objDownload.href = blobUrl;
      objDownload.click();
    });
  };

  const printPDFInApp = (reportId: string, visualizationType: number) => {
    setReportIdItemChanged(true);
    setReportId(reportId);
    setSearching(false);

      getReportPDFBase64(reportId, visualizationType).then((pdfBase64) => {
      const contentType = "application/pdf";
      const blob = b64toBlob(pdfBase64, contentType);
      const blobUrl = openPdfBlob(blob);

      var obj = document.createElement("iframe");

      obj.src = "";
      obj.src = blobUrl;
      obj.id = "pdfToShowPrint";

      var div = document.getElementById("hiddenPDFReport") as HTMLDivElement;
      div.innerHTML = "";
      div?.appendChild(obj);

      const iframeEle = document.getElementById(
        "pdfToShowPrint"
      ) as HTMLIFrameElement;

      if (iframeEle) {
        iframeEle.contentWindow!.print();
      }
    });
  };

  const b64toBlob = (b64Data: any, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize),
        byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const onChangeExpand =
    (panel: string) => (event: React.ChangeEvent<{}>, newExpanded: boolean) => {
      setExpand(newExpanded ? panel : false);
    };

  const initialSearchParam = () => {
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth(),
      d = date.getDate();
    var firstDay = format(new Date(y, m, d), "yyyy-MM-dd");
    var lastDay = format(new Date(y, m, d), "yyyy-MM-dd");

    let params = {
      CollectionDateStart: firstDay,
      CollectionDateEnd: lastDay,
      reportViewed: "T",
      reportPreviousVersions: false,
      //InstituteIds: user != null && user.instituteCnes != '' ? user.instituteCnes : []
    };

    formik.setFieldValue("CollectionDateStart", firstDay);
    formik.setFieldValue("CollectionDateEnd", lastDay);
    formik.setFieldValue("reportViewed", "T");
    formik.setFieldValue("reportPreviousVersions", false);
    //formik.setFieldValue("InstituteIds", user != null && user.instituteCnes != '' ? user.instituteCnes : []);


    getReports(params).then((response) => {
      setData(response.reportPageResponse.content);
      setTotalPages(response.reportPageResponse.totalPages);
    });
  };

  useEffect(() => {
    initialSearchParam();
  }, []);

  interface FormikErrors {
    NamePatient?: string;
    MotherName?: string;
    Batch?: string;
    general?: string; // Agora incluído explicitamente
  }

  const formik = useFormik({
    initialValues: {
      CollectionDateStart: "",
      CollectionDateEnd: "",
      InstituteIds: [],
      NamePatient: "",
      MotherName: "",
      Batch: "",
          Dnv: "",
          Prescricao: "",
      medicalRecordNumber: "",
      reportViewed: "T",
      reportPreviousVersions: false,
    },
      validate: (values): FormikErrors => {
        const errors: FormikErrors = {};

        // Validação de Instituição com outros campos
        if (user != null && !user.instituteCnes) { 
          if (values.InstituteIds != null && values.InstituteIds.length > 0 && !values.NamePatient && !values.MotherName && !values.Batch) {
              errors.general = "Quando uma instituição é selecionada, o preenchimento dos campos 'Nome do Paciente', 'Filiação' e 'Lote' é obrigatório.";
          } else if (values.Batch && (!values.InstituteIds || values.InstituteIds.length === 0)) {
            errors.general = "Quando o campo 'Lote' é preenchido, é obrigatório selecionar pelo menos uma instituição.";
          }
        }

      return errors;
    },
    onSubmit: (values, { setErrors }) => {
      if (!values?.reportPreviousVersions) {
        setLabelPrescription("Prescrição");
      }

      if (values?.reportPreviousVersions) {
        setLabelPrescription("Prescrição / Versão");
      }

      // Checa se existem erros no formulário antes de proceder
      const formErrors = formik.validateForm();
      formErrors.then(errors => {
        if (Object.keys(errors).length === 0) {
          setSearching(false);
          getReports(values).then((response) => {
            setSearching(true);
            setData(response.reportPageResponse.content);
            setTotalPages(response.reportPageResponse.totalPages);
            setSearchPerformed(true); 
          });
        } else {
          setErrors(errors);
        }
      });
    },
  });

  const clearFilter = () => {
    formik.resetForm();
    setSelectedInstitutes(initialState);
    initialSearchParam();
  };

  const handleCloseHistory = () => {
    setOpenHistory(!openHistory);
  };

    const openDialogHistory = (prescription: string, solicitacaoLis: string) => {
        setIdReportHistory(prescription);
        setIdSolicitacaoLis(solicitacaoLis);
      setOpenHistory(true);
        
  };

    const openDialogSendEmail = (idReport: string) => {
    setIdSendEmail(idReport);
      setOpenSendEmail(true);
  };

  const handleCloseSendEmail = (closeEmailSend: boolean) => {
    if (closeEmailSend) {
      setReportIdItemChanged(true);
      setSearching(false);
    }

    setOpenSendEmail(!openSendEmail);
  };

    const handlePrintAllReports = async () => {
        const lote = formik.values.Batch;
        const InstituteIds = formik.values.InstituteIds;

        if (!lote || InstituteIds.length === 0) {
            alert('Por favor, preencha os campos "Lote" e selecione pelo menos uma instituição para imprimir todos os laudos.');
            return;
        }

        setLoading(true);

        try {

            Snackbar({
                message: "Gerando arquivo em segundo plano...",
                type: "success",
            });

            const jobId = await generatePdf(formik.values);

            const interval = setInterval(async () => {
                const status = await getPdfStatus(jobId);

                if (status.status === "error") {
                    clearInterval(interval);
                    setLoading(false);
                    Snackbar({
                        message: "Ocorreu um erro ao gerar o arquivo. Tente novamente.",
                        type: "error",
                    });
                }

                if (status.ready) {
                    clearInterval(interval);
                    setLoading(false);
                    Snackbar({
                        message: "Arquivo pronto! Download iniciado.",
                        type: "success",
                    });

                    const blob = await downloadPdfZip(jobId);

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `${selectedInstitutes[0].corporateName} - Lote ${lote}.zip`;
                    a.click();
                }
            }, 10000);

        } catch (error) {
            console.error('Erro ao baixar o arquivo zip:', error);
            setLoading(false);
            alert('Ocorreu um erro ao tentar baixar o arquivo. Por favor, tente novamente.');
        }
    };

  const debouncedReports = debounce(reports, 300);
  
  const changePage = useCallback((newPage: number) => {
    if (page !== newPage) {
      setPage(newPage);
      debouncedReports(newPage);
      setReportIdItemChanged(false);
      setReportId("");
    }
  }, [page, formik.values, debouncedReports]);

  return (
    <>
      <div
        title="hiddenPDFReport"
        id="hiddenPDFReport"
        style={{ display: "none" }}
      />
      <DialogHistoryReport
              open={openHistory}
              handleClose={handleCloseHistory}
              prescription={idReportHistory}
              solicitacaoLis={idSolicitacaoLis}
      />
      <DialogSendMailReport
        open={openSendEmail}
        handleClose={handleCloseSendEmail}
              reportId={idSendEmail}
      />
      <ModalConfirmation
        open={confirmationModal.open}
        message={confirmationModal.message}
        title="Bloqueio de laudo"
        onClose={handleCloseModalConfirmation}
        onConfirm={handleBlockReport}
          />

          <ModalConfirmation
              open={confirmationModalUnblock.open}
              message={confirmationModalUnblock.message}
              title="Desbloqueio de laudo"
              onClose={handleCloseModalConfirmationUnblock}
              onConfirm={handleUnblockReport}
          />

      <Grid container>
        <Grid item xs={12} sm={12}>
          <Box mb={1}>
            <Typography
              variant="h5"
              style={{ fontWeight: "bolder" }}
              color="textPrimary"
            >
              Resultado de Exames
            </Typography>
            {/* <Typography variant='subtitle1' color='textSecondary'>
              Você pode alterar abaixo os dados anteriormente inseridos
            </Typography> */}
          </Box>
        </Grid>
      </Grid>

      <ModalSearchInstitutions
        open={open}
        onCallBack={handleSearchInstitute}
        onClose={onClose}
        resetSelection={resetInstitutesSelection}
      />

      <Accordion
        expanded={expand === "filter"}
        onChange={onChangeExpand("filter")}
      >
        <AccordionSummary aria-controls="filter" id="filter">
          {expand === "filter" ? (
            <KeyboardArrowDown style={{ marginRight: "5px" }} />
          ) : (
            <KeyboardArrowRight style={{ marginRight: "5px" }} />
          )}

          <Typography>Filtros</Typography>
        </AccordionSummary>
        <AccordionDetails style={{ display: "flex", flexDirection: "column" }}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container alignItems="flex-end">
              <Grid item xs={12} md={2}>
                <Box mb={1} mr={1}>
                  <Typography className={classes.typographyStyle}>
                    Período Solicitação:
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    margin="none"
                    label="Data Início"
                    id="start-date"
                    InputLabelProps={{ shrink: true }}
                    type="date"
                    {...formik.getFieldProps("CollectionDateStart")}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={2}>
                <Box mb={1} mr={1}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    margin="none"
                    label="Data Fim"
                    id="end-date"
                    InputLabelProps={{ shrink: true }}
                    type="date"
                    {...formik.getFieldProps("CollectionDateEnd")}
                  />
                </Box>
              </Grid>

              {user?.typeUser !== 2 && (
                <Grid item xs={12} md={3}>
                  <Box mb={1} mr={1}>
                    <Typography className={classes.typographyStyle}>
                      Instituição
                    </Typography>
                    <TextField
                      fullWidth
                      inputProps={{
                        className: "iconCursor",
                      }}
                      value={
                        selectedInstitutes.map(inst => inst.corporateName ? inst.corporateName.trim() : '')
                        .filter(name => name.length > 0)
                        .join(', ')
                      }
                      onClick={() => setOpen(true)}
                      size="small"
                      variant="outlined"
                      margin="none"
                      id="search-user-institute"
                      placeholder="Clique para selecionar a instituição"
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            {selectedInstitutes.length > 0 ? (
                              <Close
                                className="iconCursor"
                                onClick={handleChangeInstituteIcon}
                              />
                            ) : (
                              <Search className="iconCursor" />
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </Grid>
              )}
              <Grid item xs={12} md={3}>
                <Box mb={1} mr={1}>
                  <Typography className={classes.typographyStyle}>
                    Nome Paciente
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    margin="none"
                    {...formik.getFieldProps("NamePatient")}
                  />
                </Box>
              </Grid>
            

            
              <Grid item xs={12} md={2}>
                <Box mb={1} mr={1}>
                  <Typography className={classes.typographyStyle}>
                    Filiação
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    margin="none"
                    {...formik.getFieldProps("MotherName")}
                  />
                </Box>
              </Grid>
                      </Grid>
              <Grid container alignItems="flex-end">

              <Grid item xs={12} md={2}>
                <Box mb={1} mr={1}>
                  <Typography className={classes.typographyStyle}>
                    Lote
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    margin="none"
                    {...formik.getFieldProps("Batch")}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} md={2}>
                <Box mb={1} mr={1}>
                  <Typography className={classes.typographyStyle}>
                    DNV
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    margin="none"
                    {...formik.getFieldProps("Dnv")}
                  />
                </Box>
                          </Grid>

                          <Grid item xs={12} md={2}>
                              <Box mb={1} mr={1}>
                                  <Typography className={classes.typographyStyle}>
                                      Prescrição
                                  </Typography>
                                  <TextField
                                      fullWidth
                                      size="small"
                                      variant="outlined"
                                      margin="none"
                                      {...formik.getFieldProps("Prescricao")}
                                  />
                              </Box>
                          </Grid>

              <Grid item xs={12} md={2}>
                <Box mb={1} mr={1}>
                  <Typography className={classes.typographyStyle}>
                    Prontuário
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    margin="none"
                    {...formik.getFieldProps("medicalRecordNumber")}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Box mb={1} mr={1}>
                  <Typography className={classes.typographyStyle}>
                    Visualizar
                  </Typography>

                  <FormControl
                    variant="outlined"
                    size="small"
                    margin="none"
                    fullWidth
                  >
                    <Select
                      placeholder="Visualizar"
                      labelId="reportViewed"
                      id="reportViewed"
                      fullWidth
                      displayEmpty
                      onChange={(e) =>
                        formik.setFieldValue("reportViewed", e.target.value)
                      }
                      value={formik.values.reportViewed}
                      error={
                        formik.touched.reportViewed &&
                        Boolean(formik.errors.reportViewed)
                      }
                    >
                      <MenuItem value="T">Tudo</MenuItem>
                      <MenuItem value="N">Não Visualizados</MenuItem>
                      <MenuItem value="S">Visualizados</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} md={1}>
                <Box mb={1} mr={1}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                  >
                    Pesquisar
                  </Button>
                </Box>
              </Grid>

              <Grid item xs={12} md={1}>
                <Box mb={1} mr={1}>
                  <Button
                    onClick={clearFilter}
                    fullWidth
                    variant="contained"
                    color="secondary"
                  >
                    Limpar
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {user?.typeUser === 0 && (
              <Grid item xs={12} sm={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="reportPreviousVersions"
                      size="medium"
                      {...formik.getFieldProps("reportPreviousVersions")}
                      checked={formik.values.reportPreviousVersions}
                      color="primary"
                    />
                  }
                  label="Exibir versões anteriores dos laudos"
                />
              </Grid>
                      )}

                      {formik.values.Batch != '' && formik.values.InstituteIds && formik.values.InstituteIds.length > 0 && searchPerformed && data.length > 0 && (
                          <Grid className={classes.containerButtonDownloadAll} item xs={12} md={1}>
                              <Box mb={1} mr={1}>
                                  <Button
                                      onClick={handlePrintAllReports}
                                      fullWidth
                                      variant="contained"
                                      color="primary"
                                      disabled={loading}
                                  >
                                      {loading ? (
                                          <CircularProgress size={20} color="inherit" />
                                      ) : (
                                          <GetApp />
                                      )}

                                      <span style={{ marginLeft: 8 }}>
                                          {loading ? "Gerando arquivo..." : "Baixar todos os Laudos"}
                                      </span>
                                  </Button>
                              </Box>
                          </Grid>
                      )}

            
            {formik.errors.general && (
              <div
                style={{
                  textAlign: 'right',
                  color: '#ff0404',
                  position: 'relative',
                  top: '-31px',
                  marginRight: '3px',
                  backgroundColor: '#ffd9d9',
                  float: 'right',
                  borderRadius: '4px',
                  padding: '5px 10px 6px',
                  fontSize: '15px',
                  fontWeight: '500',
                }}
              >
                {formik.errors.general}
              </div>
            )}

          </form>
        </AccordionDetails>
      </Accordion>

      <DataGrid
        data={data}
        columns={columns}
        totalPages={totalPages}
        changePage={changePage}
        reportIdItemChanged={{
          page,
          changed: reportIdItemChanged,
          reportId,
          filters: formik.values,
          searching,
        }}
      />
    </>
  );
};

export default ReportsPjIJC;
